import router from './router'
import type { RouteRecordRaw } from 'vue-router'
import { isRelogin } from '@/config/axios/service'
import { getAccessToken } from '@/utils/auth'
import { useTitle } from '@/hooks/web/useTitle'
import { useNProgress } from '@/hooks/web/useNProgress'
import { usePageLoading } from '@/hooks/web/usePageLoading'
import { useDictStoreWithOut } from '@/store/modules/dict'
import { useUserStoreWithOut } from '@/store/modules/user'
import { usePermissionStoreWithOut } from '@/store/modules/permission'

const { start, done } = useNProgress()

const { loadStart, loadDone } = usePageLoading()

const getDefaultRoutePath = (routes: AppRouteRecordRaw[]): string => {
  const firstRoute = routes.find((route) => route.name !== '404Page')
  if (!firstRoute) {
    return '/403'
  }
  if (
    typeof firstRoute.redirect === 'string' &&
    firstRoute.redirect &&
    firstRoute.redirect !== 'noredirect'
  ) {
    return firstRoute.redirect
  }
  return firstRoute.path
}

// 路由不重定向白名单
const whiteList = [
  '/login',
  '/social-login',
  '/auth-redirect',
  '/bind',
  '/register',
  '/oauthLogin/gitee'
]

// 路由加载前
router.beforeEach(async (to, from) => {
  start()
  loadStart()
  if (getAccessToken()) {
    if (to.path === '/login') {
      return { path: '/' }
    } else {
      const dictStore = useDictStoreWithOut()
      const userStore = useUserStoreWithOut()
      const permissionStore = usePermissionStoreWithOut()
      // 字典是页面渲染的基础数据，路由放行前完成一次初始化
      if (!dictStore.getIsSetDict) {
        await dictStore.setDictMap()
      }
      if (!userStore.getIsSetUser) {
        isRelogin.show = true
        await userStore.setUserInfoAction()
        isRelogin.show = false
        // 后端过滤菜单
        await permissionStore.generateRoutes()
        permissionStore.getAddRouters.forEach((route) => {
          router.addRoute(route as unknown as RouteRecordRaw) // 动态添加可访问路由表
        })
        if (to.path === '/') {
          return {
            path: getDefaultRoutePath(permissionStore.getAddRouters),
            replace: true
          }
        }
        const redirectPath =
          typeof from.query.redirect === 'string' ? from.query.redirect : to.fullPath
        if (to.fullPath === redirectPath) {
          return { ...to, replace: true }
        }
        const redirectRoute = router.resolve(redirectPath)
        return {
          path: redirectRoute.path,
          query: redirectRoute.query,
          hash: redirectRoute.hash,
          replace: true
        }
      } else {
        if (to.path === '/') {
          return {
            path: getDefaultRoutePath(permissionStore.getAddRouters),
            replace: true
          }
        }
        return true
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      return true
    } else {
      return { path: '/login', query: { redirect: to.fullPath } } // 否则全部重定向到登录页
    }
  }
})

router.afterEach((to) => {
  useTitle(to?.meta?.title as string)
  done() // 结束Progress
  loadDone()
})
